// extracted by mini-css-extract-plugin
module.exports = {"Bolts":"styles_Bolts__Z-WQZ","cqlScore":"styles_cqlScore__CDWHV"};